module.exports = __webpack_public_path__ + "img/glazing-unknown.fe06e0c.svg";